import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {LogementService} from '../../services/logement.service';
import {Observable} from 'rxjs';
import {Logement} from '../../models/logement';
import {NoLogementGuard} from '../../guards/no-logement-guard.service';
import {UserService} from '../../services/user.service';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class MenuComponent implements OnInit {
  public previsualisation;

  public logements$: Observable<Logement[]>;
  public logementCourant$: Observable<Logement>;
  public isMCS = false;

  constructor(
    public logementService: LogementService,
    public router: Router,
    public guard: NoLogementGuard,
    private userService: UserService,
    public modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.previsualisation = window.self !== window.top;
    this.logements$ = this.logementService.logements;
    this.logementCourant$ = this.logementService.logementCourant;

    this.userService.load().then((user) => {
      if (user.isMCS()) {
        this.isMCS = true;
      }
    });
  }

  logout() {
    sessionStorage.clear();
    return true;
  }

  isSonergiaPartner(logement) {
    return logement?.societe?.partner?.id === environment.SonergiaPartnerId;
  }

  showAnnouncements(logement) {
    if (logement?.societe?.partner?.showAnnouncements === false) {
      return logement?.societe?.partner?.showAnnouncements
    }

    return true
  }

  isParcoursTravauxEnabled() {
    return environment.enableParcoursTravaux
  }
}
